<template>
  <div v-if="modelValue"
    class="fixed inset-0 bg-black/50 flex items-end z-[99999] isolate"
    style="position: fixed; z-index: 99999;"
    @click="handleCancel"
  >
    <div
      class="w-full rounded-t-2xl p-4 max-h-[80vh] overflow-y-auto relative isolate"
      :class="hasContractBrand ? 'bg-contrastbrand text-inverse-emphasis' : ' bg-white text-normal-standard'"
      style="position: relative; z-index: 99999;"
      @click.stop
    >
      <!-- Main content slot -->
      <slot></slot>

      <!-- Footer -->
      <div class="pt-4 my-4 border-t border-surface-level-2">
        <div class="flex flex-col items-center w-full gap-4">
          <AppButton class="w-full"
            v-if="showSave"
            :title="saveText"
            buttonType="Primary"
            :is-loading="isLoading"
            @click="$emit('save')"
          />
          <AppLink v-if="!hasContractBrand && showCancel" @click="handleCancel">
            {{ cancelText }}
          </AppLink>
          <AppButton
            v-if="hasContractBrand && showCancel"
            class="w-full"
            :title="cancelText"
            buttonType="Primary"
            :is-loading="isLoading"
            @click="handleCancel"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/components/AppButton.vue';
import AppLink from '@/components/AppLink.vue';

interface Props {
  modelValue: boolean;
  saveText?: string;
  cancelText?: string;
  showSave?: boolean;
  showCancel?: boolean;
  isLoading?: boolean;
  hasContractBrand?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  saveText: 'Save',
  cancelText: 'Cancel',
  showSave: true,
  showCancel: true,
  isLoading: false,
  hasContractBrand: false,
});


const emit = defineEmits(['update:modelValue', 'save', 'cancel']);

const handleCancel = () => {
  emit('cancel');
  emit('update:modelValue', false);
};
</script>
